<!-- eslint-disable vue/valid-v-slot -->
<template>
  <v-container>
    <v-row class="mt-5" v-if="applicationQueues">
      <v-col
        cols="3"
        v-for="(stat, i) in filterQueues"
        :key="stat.key + i"
        @click="() => stat.action(stat)"
      >
        <v-card dark rounded hover :color="stat.color">
          <v-card-title class="overline">{{ stat.name }}</v-card-title>

          <v-card-text>
            <v-row>
              <v-col
                cols="12"
                class="d-flex flex-row justify-center align-center"
              >
                <h1 class="text-h2">
                  {{ applicationQueues[stat.key] }}
                </h1>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-else>
      <v-col cols="3" v-for="stats in filterQueues" :key="stats.key">
        <v-skeleton-loader type="image" height="150px" />
      </v-col>
    </v-row>

    <!--    <v-row class="mt-10">-->
    <!--      <v-col cols="12">-->
    <!--        <v-card>-->
    <!--          <v-card-title class="overline">-->
    <!--            Weekly Applications-->

    <!--            <v-spacer />-->

    <!--            <span class="caption"> Last 12 Weeks</span>-->
    <!--          </v-card-title>-->
    <!--          <v-card-text>-->
    <!--            <line-chart-->
    <!--              :chart-data="weeklyApplications.data"-->
    <!--              :options="weeklyApplications.options"-->
    <!--            />-->
    <!--          </v-card-text>-->
    <!--        </v-card>-->
    <!--      </v-col>-->

    <!--      <v-col cols="6">-->
    <!--        <v-card>-->
    <!--          <v-card-title> Applications By Gender </v-card-title>-->
    <!--          <v-card-text>-->
    <!--            <pie-chart-->
    <!--              :chart-data="genderStats.data"-->
    <!--              :options="genderStats.options"-->
    <!--            />-->
    <!--          </v-card-text>-->
    <!--        </v-card>-->
    <!--      </v-col>-->
    <!--    </v-row>-->

    <v-row class="mt-10">
      <v-col cols="12">
        <v-card>
          <v-card-title>Applications By Stages</v-card-title>
          <v-card-text>
            <bar-chart
              :chart-data="reviewStats.data"
              :options="reviewStats.options"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col cols="12">
        <v-card>
          <v-card-title>Applications Status </v-card-title>
          <v-card-text>
            <template>
              <line-chart
                :chart-data="applicationStats.data"
                :options="applicationStats.options"
              />
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col cols="12">
        <v-card>
          <v-card-title>Targeted vs. Actual Approved Applications</v-card-title>
          <v-card-text>
            <bar-chart
              :chart-data="approvalStats.data"
              :options="approvalStats.options"
            />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col cols="6">
        <v-card>
          <v-card-title> Applications by Reviewer </v-card-title>
          <v-card-text v-if="applicationReviewLogsStats">
            <PieEChart :pieData="applicationReviewLogsStats" />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card>
          <v-card-title> Upgrades by Reviewer </v-card-title>
          <v-card-text v-if="upgradeReviewLogs">
            <PieEChart :pieData="upgradeReviewLogs" />
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog v-model="cueueDialog" persistent max-width="1490px">
        <v-card :ref="queueApplications">
          <v-card-title>
            <v-toolbar flat>
              <v-toolbar-title>
                {{ activeCueue.name }}
              </v-toolbar-title>
              <v-spacer />
              <v-btn plain @click="closeCueueDialog" color="danger">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-row align="center" justify="center" class="mb-6">
              <v-col cols="12">
                <v-card
                  class="pa-2"
                  elevation="0"
                  style="
                    border-radius: 32px;
                    background: linear-gradient(
                      90deg,
                      #f5f7fa 0%,
                      #c3cfe2 100%
                    );
                  "
                >
                  <v-row align="center" no-gutters>
                    <v-col cols="10">
                      <v-text-field
                        v-model="search"
                        :label="`Search ${activeCueue.name} applications...`"
                        placeholder="Applicant name, Application No., or RPFile ID"
                        outlined
                        clearable
                        clear-icon="mdi-close-circle-outline"
                        hide-details
                        rounded
                        dense
                        prepend-inner-icon="mdi-magnify"
                        class="modern-search-input"
                        @change="onInpuntChange"
                        @click:clear="searchApplication"
                        style="
                          background: rgba(255, 255, 255, 0.7);
                          border-radius: 24px;
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2" class="d-flex align-center justify-center">
                      <v-btn
                        color="primary"
                        elevation="2"
                        rounded
                        large
                        class="modern-search-btn"
                        style="min-width: 56px; height: 56px"
                        @click="searchApplication"
                      >
                        <v-icon size="32">mdi-magnify</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
            <v-data-table
              :headers="cueueApplicationsHeader"
              :items="filteredQueueApplications"
            >
              <template v-slot:item.numberCode="{ index }">
                <!-- Robust numbering logic considering pagination -->
                <span>
                  #{{
                    (($refs.queueApplications?.page || 1) - 1) *
                      ($refs.queueApplications?.itemsPerPage || 10) +
                    index +
                    1
                  }}
                </span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-card-actions>
                  <v-btn
                    @click="viewCueueApplicationComment(item)"
                    text
                    color="info"
                    class="text-decoration-underline"
                  >
                    <span style="text-transform: lowercase">see comments</span>
                  </v-btn>
                  <v-btn
                    @click="openDetailedApplication(item)"
                    text
                    color="info"
                    class="text-decoration-underline"
                  >
                    <span style="text-transform: lowercase">view</span>
                  </v-btn>
                </v-card-actions>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- <v-row>
      <v-dialog v-model="cueueDialog" persistent max-width="1490px">
        <v-card :ref="queueApplications">
          <v-card-title>
            <v-toolbar flat>
              <v-toolbar-title>
                {{ activeCueue.name }}
              </v-toolbar-title>
              <v-spacer />
              <v-btn plain @click="closeCueueDialog" color="danger">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="search"
              :label="`search ${activeCueue.name} applications using applicant name, application No. or rpfile ID.`"
              outlined
              clearable
              clear-icon="mdi-close-circle-outline"
            ></v-text-field>
            <v-btn text>
              <v-icon> mdi-magnify </v-icon>
            </v-btn>
            <v-data-table
              :headers="cueueApplicationsHeader"
              :items="queueApplications"
            >
              <template v-slot:item.actions="{ item }">
                <v-card-actions>
                  <v-btn
                    @click="viewCueueApplicationComment(item)"
                    text
                    color="info"
                    class="text-decoration-underline"
                  >
                    <span style="text-transform: lowercase">see comments</span>
                  </v-btn>
                  <v-btn
                    @click="openDetailedApplication(item)"
                    text
                    color="info"
                    class="text-decoration-underline"
                  >
                    <span style="text-transform: lowercase">view</span>
                  </v-btn>
                </v-card-actions>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row> -->
    <v-row>
      <v-dialog v-model="cueueApplicationCommentDialog" max-width="800px">
        <v-card>
          <v-card-title>
            <v-toolbar flat>
              <v-toolbar-title>
                comments for {{ activeSelectedRow.FullNames }}({{
                  activeSelectedRow.Code
                }}) application
              </v-toolbar-title>
            </v-toolbar>
          </v-card-title>
          <v-card-text>
            <v-list- two-line>
              <v-list-item
                v-for="(comment, index) in applicationComments"
                :key="index"
                class="comment-item"
              >
                <v-list-item-avatar>
                  <v-avatar size="40">
                    <v-img
                      src="../../../assets/default_avatar.jpg"
                      alt="Avatar"
                    />
                  </v-avatar>
                </v-list-item-avatar>

                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    {{ comment.displayName || comment.userID }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="grey--text text--darken-1 text-caption">
                      {{ formatDate(comment.commentDate, 10) }}
                    </span>
                    <div
                      class="mt-2"
                      style="white-space: normal; word-wrap: break-word"
                    >
                      {{ comment.comment }}
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>

                <!-- <v-list-item-action>
                  <v-btn icon @click="replyTo(comment)">
                    <v-icon small>mdi-reply</v-icon>
                  </v-btn>
                  <v-btn icon @click="deleteComment(index)">
                    <v-icon small color="red">mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action> -->
              </v-list-item>
            </v-list->
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { BarChart, HasChart, LineChart, PieChart } from "@/modules/charts";
import { helper } from "@/utils";
import PieEChart from "@/modules/charts/PieEChart.vue";
import { appName } from "@/environment";
import { DateMixin } from "@/mixins";
import Application from "@/modules/application/models/application";
import Upgrade from "@/modules/upgrade/models/upgrade";

// import _ from "lodash";
export default {
  name: "applicationDashboard",
  // eslint-disable-next-line vue/no-unused-components
  components: { BarChart, PieChart, LineChart, PieEChart },
  mixins: [HasChart, DateMixin],
  data: function () {
    return {
      filteredQueueApplications: [],
      search: "",
      cueueDialog: false,
      cueueApplicationCommentDialog: false,
      activeCueue: {},
      activeSelectedRow: {},
      queues: [
        {
          name: "Total applications In Review",
          key: "Review",
          color: "blue",
          type: "membership",
          action: async (item) => {
            await this.$store.dispatch("Dashboard/fetchCueueApplications", {
              resource: this.$route?.meta?.name,
              status: item.key,
            });
            this.activeCueue = item;
            this.cueueDialog = true;
          },
        },
        {
          name: "Total applications Approved",
          key: "Approved",
          color: "green",
          type: "membership",
          action: async (item) => {
            await this.$store.dispatch("Dashboard/fetchCueueApplications", {
              resource: this.$route?.meta?.name,
              status: item.key,
            });
            this.activeCueue = item;
            this.cueueDialog = true;
          },
        },
        {
          name: "Total applications On Hold",
          key: "OnHold",
          color: "orange",
          type: "membership",
          action: async (item) => {
            await this.$store.dispatch("Dashboard/fetchCueueApplications", {
              resource: this.$route?.meta?.name,
              status: item.key,
            });
            this.activeCueue = item;
            this.cueueDialog = true;
          },
        },
        {
          name: "Total applications Declined",
          key: "Declined",
          color: "red",
          type: "membership",
          action: async (item) => {
            await this.$store.dispatch("Dashboard/fetchCueueApplications", {
              resource: this.$route?.meta?.name,
              status: item.key,
            });
            this.activeCueue = item;
            this.cueueDialog = true;
          },
        },
        {
          name: "Total Assigned",
          key: "assigned",
          color: "#55CC55",
          type: "grant",
        },
        {
          name: "In progress",
          key: "inprogress",
          color: "orange",
          type: "grant",
        },
        {
          name: "Submitted",
          key: "submitted",
          color: "blue",
          type: "grant",
        },
      ],
      chartStatus: ["Released", "Review"],
      grantChartStatus: ["Assigned", "In Progress", "Submitted"],
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      v.$store.dispatch("Setup/getSubscriptionPeriods");
    });
  },
  mounted() {
    document.addEventListener("keypress", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        this.searchApplication();
      }
    });
    setTimeout(() => {
      if (this.$route.query.tab) {
        const tab = JSON.parse(atob(this.$route.query.tab) || "");
        this.$store.dispatch("Dashboard/fetchCueueApplications", {
          resource: this.$route?.meta?.name,
          status: tab.key,
        });
        this.activeCueue = tab;
        this.cueueDialog = true;
      }
    }, 1500);
  },
  computed: {
    queueApplications() {
      return this.$store.getters["Dashboard/getCueueApplications"];
    },
    applicationComments() {
      return this.$store.getters["Dashboard/getApplicationComments"];
    },
    cueueApplicationsHeader() {
      return [
        {
          text: "#SN",
          sortable: false,
          value: "numberCode",
        },
        {
          text: "Application Code",
          sortable: false,
          value: "Code",
        },
        {
          text: "Applicant Name",
          sortable: false,
          value: "FullNames",
        },
        {
          text: "Gender",
          sortable: false,
          value: "Gender",
        },
        {
          text: "Applied Category",
          sortable: true,
          value: "AppliedCategory",
        },
        {
          text: "Applicant Discipline",
          sortable: false,
          value: "Discipline",
        },
        {
          text: "Application Date",
          sortable: false,
          value: "Discipline",
        },
        {
          text: "Actions",
          sortable: false,
          value: "actions",
        },
      ];
    },
    filterQueues() {
      return this.queues.filter((queue) => queue.type !== "grant");
    },
    applicationQueues() {
      let stats = this.$store.getters["Dashboard/dateStatistics"];

      if (!stats) return null;

      delete stats.Count;

      let queue = {};

      for (let key in stats) {
        stats[key].forEach((d) => {
          for (let q in d) {
            queue[q] = parseInt(queue[q] || 0) + parseInt(d[q]);
          }
        });
      }
      return queue;
    },

    applicationStats() {
      let data = this.$store.getters["Dashboard/dateStatistics"] || [];

      if (data) delete data.Count;

      let dataset = {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: "percentage",
            precision: 1,
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "This title",
            },
          },
        },

        data: {
          labels: [],
          datasets: [
            {
              label: "Released",
              borderColor: "rgba(76,175,80, .7)",
              backgroundColor: "rgba(76,175,80, .1)",
              data: [],
            },
            {
              label: "Review",
              borderColor: "rgba(33,150,243, .7)",
              backgroundColor: "rgb(33,150,243, .1)",
              data: [],
            },
          ],
        },
      };

      for (let key in data) {
        dataset.data.labels.push(key);

        data[key].forEach((d) => {
          for (let q in d) {
            if (this.chartStatus.includes(q)) {
              dataset.data.datasets.map((s) => {
                if (s.label === q) {
                  s.data.push(d[q]);
                }
              });
            }
          }
        });
      }

      return dataset; //
    },

    reviewStats() {
      let dataset = {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: "percentage",
            precision: 1,
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Application by Date",
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
        },
        data: {
          labels: [],
          datasets: [
            {
              label: "Female",
              backgroundColor: "rgba(233, 30, 99, .7)",
              data: [],
            },
            {
              label: "Male",
              backgroundColor: "rgba(33, 150, 243, .7)",
              data: [],
            },
            // {
            //   label: "Other",
            //   backgroundColor: "rgba(96, 125, 139, .7)",
            //   data: [],
            // },
          ],
        },
      };
      let data = this.$store.getters["Dashboard/reviewStats"];

      if (!data) return dataset;

      for (let key in data) {
        dataset.data.labels.push(key);

        for (let g in data[key]["gender"]) {
          dataset.data.datasets.map((d) => {
            if (d.label === g) {
              d.data.push(data[key]["gender"][g]);
            }
          });
        }
      }

      return dataset;
    },

    applicationReviewLogsStats() {
      let data = this.$store.getters["Dashboard/reviewLogs"];

      if (!data.applicationLogs) return null;

      return {
        data: Object.keys(data.applicationLogs).map((key) => {
          return data.applicationLogs[key].length;
        }),
        labels: Object.keys(data.applicationLogs),
        title: "",
        backgroundColor: Object.keys(data.applicationLogs).map((key) => {
          return helper.stringToColour(key);
        }),
        id: "applogs",
      };
    },

    upgradeReviewLogs() {
      let data = this.$store.getters["Dashboard/reviewLogs"];

      if (!data.upgradeLogs) return null;

      return {
        data: Object.keys(data.upgradeLogs).map((key) => {
          return data.upgradeLogs[key].length;
        }),
        labels: Object.keys(data.upgradeLogs),
        title: "",
        backgroundColor: Object.keys(data.upgradeLogs).map((key) => {
          return helper.stringToColour(key);
        }),
        id: "upgradelogs",
      };
    },
    authUser() {
      return JSON.parse(localStorage.getItem(`${appName}_user`) || "[]");
    },

    approvalStats() {
      let dataset = {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          pieceLabel: {
            mode: "percentage",
            precision: 1,
          },
          plugins: {
            legend: {
              position: "top",
            },
            title: {
              display: true,
              text: "Target Vs Actual",
            },
          },
          scales: {
            xAxes: [
              {
                stacked: true,
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
        },
        data: {
          labels: [],
          datasets: [
            {
              label: "Actual",
              backgroundColor: "rgba(233, 30, 99, .7)",
              data: [],
            },
            {
              label: "Target",
              backgroundColor: "rgba(63, 81, 181, .7)",
              data: [],
            },
          ],
        },
      };
      let data = this.subscriptionReportingPeriods;
      if (!data) return dataset;
      for (let period of data) {
        dataset.data.labels.push(period.description);
        dataset.data.datasets[0].data.push(period.actual);
        dataset.data.datasets[1].data.push(period.target);
      }

      return dataset;
    },
    subscriptionReportingPeriods() {
      const reportingPeriods = this.$store.getters[
        "Setup/subscriptionPeriod"
      ].map((item) => item.subscriptionReportingPeriods);
      return [].concat(...reportingPeriods);
    },
  },
  watch: {
    queueApplications(newValue) {
      this.filteredQueueApplications = newValue;
    },
  },

  methods: {
    searchApplication() {
      if (this.search || this.search !== "") {
        this.filteredQueueApplications = this.queueApplications?.filter(
          (record) => {
            const optionsArray = [
              record.FullNames.toLowerCase(),
              record.Code.toLowerCase(),
              record.ProfileID.toLowerCase(),
            ];
            return optionsArray
              .join()
              .includes(this.search.toLocaleLowerCase().trim());
          }
        );
      } else {
        this.filteredQueueApplications = this.queueApplications;
      }
    },
    onInpuntChange() {
      setTimeout(() => {
        this.searchApplication();
      }, 300);
    },
    viewCueueApplicationComment(item) {
      this.$store.dispatch("Dashboard/fetchApplicationComments", {
        documentNo: item.Code,
      });
      this.activeSelectedRow = item;
      this.cueueApplicationCommentDialog = true;
    },
    openDetailedApplication(item) {
      const models = {
        Application: Application,
        Upgrade: Upgrade,
      };
      let keyName = null;
      if ("Code" in item) {
        keyName = "Code";
      }
      if ("code" in item) {
        keyName = "code";
      }
      const instanciatedItem = new models[this.$route.meta?.name](item);
      instanciatedItem.loadProfile();
      this.$router.push({
        name: "Review Card",
        params: {
          Code: item.Code || item.code,
        },
        query: {
          type: this.$route.meta?.name?.toLowerCase(),
          redirect: this.$route.fullPath,
          tab: btoa(JSON.stringify(this.activeCueue)),
          keyName: keyName,
        },
      });
    },
    closeCueueDialog() {
      this.$store.commit("Dashboard/SET_CUEUE_APPLICATIONS", []);
      this.$store.commit("Dashboard/SET_APPLICATION_COMMENTS", []);
      this.activeCueue = {};
      this.cueueDialog = false;
      if (Object.keys(this.$route.query || {}).length) {
        this.$router.replace({ path: this.$route.path }).catch(() => {});
      }
    },
    getColorByStatus: function (status) {
      return {
        All: "blue",
        Approved: "green",
        Declined: "red",
        Onhold: "orange",
        New: "teal",
        Pending: "grey",
      }[status];
    },
  },
};
</script>

<style scoped></style>
